<div class="flex h-full flex-col overflow-hidden">
  @if (!hideViewSelector()) {
    <div class="flex w-full flex-row gap-2 px-0 py-2 pb-0">
      <sia-select-box
        class="w-full md:w-1/2"
        label="Schema vista"
        [(value)]="template.viewSchema"
        [selectBoxOptions]="{
          disableEmptyElement: false,
          value: template.viewSchema,
          dbKey: 'web.v_schemas',
        }"
        (valueChanged)="loadFirstRow()"
      >
      </sia-select-box>
      <sia-select-box
        class="w-full md:w-1/2"
        label="Nome vista"
        [(value)]="template.viewName"
        [selectBoxOptions]="{
          disableEmptyElement: false,
          value: template.viewName,
          dbKey: 'web.v_dbobjects',
          foreignKey: template.viewSchema,
        }"
        [foreignKey]="template.viewSchema"
        (valueChanged)="loadFirstRow()"
      >
      </sia-select-box>
    </div>
  }

  <!-- Main 3-column layout -->
  <div class="flex min-h-0 flex-1 flex-row gap-2 px-0 py-2">
    <!-- LEFT: Element IDs list (scrollable) -->
    @if (elementIds && elementIds.length > 0) {
      <div
        class="surface-low flex w-[200px] min-w-[200px] flex-col gap-1 rounded-lg p-2"
      >
        <sia-search-box
          class="sticky top-0 z-10 shrink-0"
          [(searchExp)]="elementSearchExp"
          (searchClicked)="filterElements($event)"
          surfaceClass="surface-high"
        ></sia-search-box>
        <div class="flex flex-col gap-1 overflow-auto">
          @for (element of filteredElementIds; track element) {
            <div
              class="sia-hover flex w-full cursor-pointer flex-row items-center rounded-md px-3 py-2 transition-colors"
              (click)="editElement(element.id)"
              [class]="
                selectedElement?.id == element.id
                  ? 'bg-primary-container text-on-primary-container'
                  : 'surface-high'
              "
            >
              <span
                class="text-primary w-full truncate text-sm font-semibold"
                >{{ element.id }}</span
              >
            </div>
          }
        </div>
      </div>
    }

    <!-- CENTER: Preview + HTML Editor -->
    <div class="flex min-w-0 flex-[3] flex-col gap-2">
      <!-- Preview -->
      <div
        class="w-full shrink-0 overflow-auto rounded-lg p-2"
        id="render"
        style="border: 1px solid !important; max-height: 30vh"
      >
        @if (template && data) {
          <sia-template-renderer
            [template]="template"
            [data]="data"
          ></sia-template-renderer>
        }
      </div>

      <!-- HTML Editor fills remaining space -->
      <html-editor
        class="min-h-0 flex-1"
        [(htmlCode)]="this.template.html"
        [title]="'Template HTML'"
        (htmlCodeChange)="onHtmlChanged($event)"
      >
      </html-editor>
    </div>

    <!-- RIGHT: Element configuration panel (scrollable) -->
    @if (selectedElement && selectedElement.dataToInject) {
      <div
        class="surface flex min-w-[400px] flex-[2] flex-col gap-2 overflow-auto rounded-xl p-2 pb-12"
      >
        <!-- Header with save button -->
        <div class="flex items-center justify-between">
          <span class="text-on-surface text-base font-semibold">
            <span class="text-primary">#{{ selectedElement.id }}</span>
          </span>
          <button mat-flat-button (click)="saveElementConfiguration()">
            <mat-icon>save_as</mat-icon>
            {{ 'Salva' | siaTranslate }}
          </button>
        </div>

        <mat-divider></mat-divider>

        <!-- Data binding section -->
        <span
          class="text-on-surface-variant text-xs font-semibold uppercase tracking-wide"
        >
          {{ 'Data Binding' | siaTranslate }}
        </span>

        <div class="flex flex-col gap-2">
          <div class="flex flex-row gap-2">
            <sia-select-box
              class="flex-1"
              label="Data Field"
              [(value)]="selectedElement.dataToInject.dataField"
              [selectBoxOptions]="{
                fixedDataSource: dataProperties,
                disableEmptyElement: false,
                value: selectedElement.dataToInject.dataField,
              }"
            ></sia-select-box>
            <sia-text-box
              class="flex-1"
              label="Attributo"
              [(value)]="selectedElement.dataToInject.attribute"
            ></sia-text-box>
          </div>

          <div class="flex flex-row gap-2">
            <sia-text-box
              class="flex-1"
              label="Formato"
              [(value)]="selectedElement.dataToInject.format"
            ></sia-text-box>
            <sia-select-box
              class="flex-1"
              label="Pipe"
              [(value)]="selectedElement.dataToInject.pipe"
              [selectBoxOptions]="{
                fixedDataSource: dataPipes,
                disableEmptyElement: false,
                value: selectedElement.dataToInject.pipe,
              }"
            ></sia-select-box>
          </div>

          <div class="flex flex-row flex-wrap gap-x-4 gap-y-1">
            <sia-check-box
              label="Attributo è una proprietà"
              [(value)]="selectedElement.dataToInject.attributeIsProperty"
            ></sia-check-box>
            <sia-check-box
              label="Usa Script per i dati"
              [(value)]="selectedElement.dataToInject.useScript"
            ></sia-check-box>
            <sia-check-box
              label="Traducibile"
              [(value)]="selectedElement.dataToInject.canTranslate"
            ></sia-check-box>
          </div>

          @if (selectedElement.dataToInject.useScript) {
            <sia-js-editor
              class="w-full"
              [(jsCode)]="selectedElement.dataToInject.dataScript"
              title="Script per dati"
            ></sia-js-editor>
          }
        </div>

        <mat-divider></mat-divider>

        <!-- CSS Conditions section -->
        <div class="flex items-center justify-between">
          <span
            class="text-on-surface-variant text-xs font-semibold uppercase tracking-wide"
          >
            {{ 'Condizioni CSS' | siaTranslate }}
          </span>
          <button
            mat-icon-button
            (click)="addCssCondition()"
            matTooltip="Nuova condizione CSS"
          >
            <mat-icon>add</mat-icon>
          </button>
        </div>

        @for (
          condition of selectedElement.cssConditions;
          track $index;
          let isLast = $last
        ) {
          <div class="surface-low flex w-full flex-col gap-2 rounded-lg p-3">
            <sia-select-box
              class="w-full"
              label="Property"
              [(value)]="condition.property"
              [selectBoxOptions]="{
                fixedDataSource: cssProperties,
                disableEmptyElement: false,
                value: condition.property,
              }"
            ></sia-select-box>
            <sia-js-editor
              class="w-full"
              title="Condition"
              [(jsCode)]="condition.script"
            ></sia-js-editor>
            @if (condition.property == 'style') {
              <sia-css-editor
                class="w-full"
                title="Stile"
                [(cssCode)]="condition.value"
              ></sia-css-editor>
            } @else {
              <sia-text-box
                class="w-full"
                label="Classi"
                [(value)]="condition.value"
              ></sia-text-box>
            }
            <button
              mat-button
              class="error self-end"
              (click)="removeCssCondition($index)"
            >
              <mat-icon>delete</mat-icon> {{ 'Rimuovi' | siaTranslate }}
            </button>
          </div>
        }

        <mat-divider></mat-divider>

        <!-- Events section -->
        <div class="flex items-center justify-between">
          <span
            class="text-on-surface-variant text-xs font-semibold uppercase tracking-wide"
          >
            {{ 'Eventi' | siaTranslate }}
          </span>
          <button
            mat-icon-button
            (click)="addEventHandler()"
            matTooltip="Nuovo evento"
          >
            <mat-icon>add</mat-icon>
          </button>
        </div>

        @for (
          eventHandler of selectedElement.eventHandlers;
          track $index;
          let isLast = $last
        ) {
          <div class="surface-low flex w-full flex-col gap-2 rounded-lg p-3">
            <div class="flex flex-row gap-2">
              <sia-select-box
                class="flex-1"
                label="Evento"
                [(value)]="eventHandler.event"
                [selectBoxOptions]="{
                  fixedDataSource: eventTypes,
                  disableEmptyElement: false,
                  value: eventHandler.event,
                }"
              ></sia-select-box>
              <sia-check-box
                label="Prevenire Default"
                [(value)]="eventHandler.preventDefault"
              ></sia-check-box>
            </div>
            <sia-js-editor
              class="block"
              title="Script"
              [(jsCode)]="eventHandler.script"
            ></sia-js-editor>
            <button
              mat-button
              class="error self-end"
              (click)="removeEventHandler($index)"
            >
              <mat-icon>delete</mat-icon> {{ 'Rimuovi' | siaTranslate }}
            </button>
          </div>
        }
      </div>
    }
  </div>
</div>
